export default __webpack_public_path__ + "static/media/nftpopup2.91712a4c.svg";